import React, { useState } from "react";
import { Form, Field, InputSubmit, Error } from './ui/Form';

// validation
import useValidation from '../hooks/useValidation';
import validateVisit from '../validation/validateVisit';

const STATE_INICIAL = {
  name: '',
  lastname: '',
  email: '',
  date: ''
}




  // hook routing to redirect
  //const router = useRouter();
  /* i created the functions to be ready when firebase data is ready
  // crud firebase
  const { usuario, firebase } = useContext(FirebaseContext);

  async function setVisit() {

    // create visit object
    const visit= {
        name,
        lastname,
        email,
        date
    }

    // insert into db
    firebase.db.collection('visits').add(visit);

    return router.push('/');

  } */
const BookVisit = () => {
  const [ error, setError] = useState(false);
  const setVisit = () => {
    console.log(name,lastname,email,date);
  }
const { values, errors, handleSubmit, handleChange, handleBlur } = useValidation(STATE_INICIAL, validateVisit, setVisit);

const { name, lastname, email, date } = values;



  return (

    <div className="container">
    <div className="header">
    
    {error}
      <Form
              onSubmit={handleSubmit}
              noValidate
            >
                  <h2 className="heading">
        Book a visit</h2>
              <fieldset>
                <legend> We need this information to book your visit:</legend>
            
                <Field>
                    <label htmlFor="name">Name</label>
                    <input 
                        type="text"
                        id="name"
                        placeholder="Your Name"
                        name="name"
                        value={name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </Field>

                { errors.name && <Error>{errors.name}</Error> }

                <Field>
                    <label htmlFor="lastname">Lastname</label>
                    <input 
                        type="text"
                        id="lastname"
                        placeholder="Your Lastname"
                        name="lastname"
                        value={lastname}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </Field>
                { errors.lastname && <Error>{errors.lastname}</Error> }

                <Field>
                    <label htmlFor="email">Email</label>
                    <input 
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Email Address"
                        value={email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </Field>

                { errors.email && <Error>{errors.email}</Error> } 

                <Field>
                    <label htmlFor="date">Date</label>
                    <input 
                        type="date"
                        id="date"
                        name="date"
                        placeholder="Date"
                        value={date}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </Field>

                { errors.date && <Error>{errors.date}</Error> } 
              </fieldset>


                 {error && <Error>{error} </Error>} 
    
                 <InputSubmit
                  type="submit"
                  value="Book visit"
                />
            </Form>
      </div>
    </div>
  );
};

export default BookVisit;
